__turbopack_context__.v({
  "className": "handlee_871d08d4-module__9TfauG__className",
});
